export var CashieringRoute;
(function (CashieringRoute) {
    CashieringRoute["Withdraw"] = "withdraw";
    CashieringRoute["Deposit"] = "deposit";
    CashieringRoute["Accounts"] = "accounts";
    CashieringRoute["OAuthPlaidRedirect"] = "oauth";
    CashieringRoute["ScheduledTransfer"] = "scheduled-transfer";
})(CashieringRoute || (CashieringRoute = {}));
export var CashieringView;
(function (CashieringView) {
    CashieringView["Authorize"] = "authorize";
    CashieringView["Amount"] = "amount";
    CashieringView["Type"] = "type";
    CashieringView["Review"] = "review";
    CashieringView["Manage"] = "manage";
    CashieringView["OAuthPlaidRedirect"] = "oauth";
    CashieringView["ScheduledTransferType"] = "scheduled-transfer-type";
    CashieringView["ScheduledTransferAmount"] = "scheduled-transfer-amount";
    CashieringView["ScheduledTransferReview"] = "scheduled-transfer-review";
})(CashieringView || (CashieringView = {}));
export var CashieringManageAction;
(function (CashieringManageAction) {
    CashieringManageAction["Add"] = "add";
    CashieringManageAction["AddOptions"] = "add-options";
    CashieringManageAction["Verify"] = "verify";
    CashieringManageAction["Rename"] = "rename";
    CashieringManageAction["Delete"] = "delete";
    CashieringManageAction["Close"] = "close";
    CashieringManageAction["Upload"] = "upload";
})(CashieringManageAction || (CashieringManageAction = {}));
export var WireType;
(function (WireType) {
    WireType["Domestic"] = "domestic";
    WireType["International"] = "international";
})(WireType || (WireType = {}));
export var WireAccountType;
(function (WireAccountType) {
    WireAccountType["SelfOwned"] = "self-owned";
    WireAccountType["ThirdParty"] = "third-party";
})(WireAccountType || (WireAccountType = {}));
export var TransferBankIdentifierType;
(function (TransferBankIdentifierType) {
    TransferBankIdentifierType["ABA"] = "ABA";
    TransferBankIdentifierType["BIC"] = "BIC";
})(TransferBankIdentifierType || (TransferBankIdentifierType = {}));
export const TransferPendingStates = ['PendingRepCreateApproval', 'PendingFirmCreateApproval'];
export const TransferStates = [
    ...TransferPendingStates,
    'Rejected',
    'Canceled',
    'Approved',
    'FundsHeld',
    'FundsPosted',
    'SentToBank',
    'Complete',
    'Void',
    'Returned',
    'StopPayment',
    'Pending',
    'PendingPrinting',
];
// All transfer states that do not impact the current day ACH limit
export const TransferStatesNotAffectingAchLimit = [
    'Rejected',
    'CreateRejected',
    'Canceled',
    'Void',
    'Returned',
    'StopPayment',
    'FailedAtBank',
];
export var TaxWithholdingType;
(function (TaxWithholdingType) {
    TaxWithholdingType["Fixed"] = "Fixed";
    TaxWithholdingType["Percent"] = "Percentage";
})(TaxWithholdingType || (TaxWithholdingType = {}));
export var TransferRecipientBankState;
(function (TransferRecipientBankState) {
    TransferRecipientBankState["Pending"] = "Pending";
    TransferRecipientBankState["PendingFirmApproval"] = "PendingFirmApproval";
    TransferRecipientBankState["Approved"] = "Approved";
    TransferRecipientBankState["Rejected"] = "Rejected";
})(TransferRecipientBankState || (TransferRecipientBankState = {}));
export const AchRelationshipPendingStates = [
    'PendingCreateApproval',
    'PendingCancelApproval',
];
export const CashieringPendingStates = [
    ...AchRelationshipPendingStates,
    ...TransferPendingStates,
];
export var BankRiskScoreValues;
(function (BankRiskScoreValues) {
    BankRiskScoreValues["LowRisk"] = "LowRisk";
    BankRiskScoreValues["MediumRisk"] = "MediumRisk";
    BankRiskScoreValues["HighRisk"] = "HighRisk";
})(BankRiskScoreValues || (BankRiskScoreValues = {}));
export var TransferIRAContributionType;
(function (TransferIRAContributionType) {
    TransferIRAContributionType["Regular"] = "Regular";
    TransferIRAContributionType["Employee"] = "Employee";
    TransferIRAContributionType["Employer"] = "Employer";
    TransferIRAContributionType["ReCharacterization"] = "ReCharacterization";
    TransferIRAContributionType["Transfer"] = "Transfer";
    TransferIRAContributionType["Repayment"] = "Repayment";
    TransferIRAContributionType["Conversion"] = "Conversion";
    TransferIRAContributionType["ApexRollover60Day"] = "ApexRollover60Day";
    TransferIRAContributionType["ApexRolloverDirect"] = "ApexRolloverDirect";
    TransferIRAContributionType["ApexTrusteeFee"] = "ApexTrusteeFee";
    TransferIRAContributionType["RqdRollover"] = "RqdRollover";
    TransferIRAContributionType["RqdSep"] = "RqdSep";
    TransferIRAContributionType["RqdCatchup"] = "RqdCatchup";
})(TransferIRAContributionType || (TransferIRAContributionType = {}));
export var TransferIRADistributionReason;
(function (TransferIRADistributionReason) {
    TransferIRADistributionReason["Normal"] = "Normal";
    TransferIRADistributionReason["Disability"] = "Disability";
    TransferIRADistributionReason["Premature"] = "Premature";
    TransferIRADistributionReason["Death"] = "Death";
    TransferIRADistributionReason["ExcessContributionRemovalBeforeTaxDeadline"] = "ExcessContributionRemovalBeforeTaxDeadline";
    TransferIRADistributionReason["ExcessContributionRemovalAfterTaxDeadline"] = "ExcessContributionRemovalAfterTaxDeadline";
    TransferIRADistributionReason["RolloverToQualifiedPlan"] = "RolloverToQualifiedPlan";
    TransferIRADistributionReason["ReCharacterizationPriorYear"] = "ReCharacterizationPriorYear";
    TransferIRADistributionReason["ReCharacterizationCurrentYear"] = "ReCharacterizationCurrentYear";
    TransferIRADistributionReason["ApexTransfer"] = "ApexTransfer";
    TransferIRADistributionReason["ApexManagementFee"] = "ApexManagementFee";
    TransferIRADistributionReason["ApexPrematureSimpleIRALessThan2Years"] = "ApexPrematureSimpleIRALessThan2Years";
    TransferIRADistributionReason["ApexNormalRothIRAGreaterThan5Years"] = "ApexNormalRothIRAGreaterThan5Years";
    TransferIRADistributionReason["RqdPrematureExceptionApplies"] = "RqdPrematureExceptionApplies";
    TransferIRADistributionReason["RqdDeathRemoveExcessCurrentYear"] = "RqdDeathRemoveExcessCurrentYear";
    TransferIRADistributionReason["RqdDeathRemoveExcessPriorYear"] = "RqdDeathRemoveExcessPriorYear";
    TransferIRADistributionReason["RqdDeathRemoveExcessTwoYearsPrior"] = "RqdDeathRemoveExcessTwoYearsPrior";
    TransferIRADistributionReason["RqdDeathRolloverForSurvivingSpouse"] = "RqdDeathRolloverForSurvivingSpouse";
    TransferIRADistributionReason["RqdRemoveExcessExceptionApplies"] = "RqdRemoveExcessExceptionApplies";
    TransferIRADistributionReason["RqdRemoveExcessTwoYearsPrior"] = "RqdRemoveExcessTwoYearsPrior";
    TransferIRADistributionReason["RqdRemoveExcessTwoYearsPriorExceptionApplies"] = "RqdRemoveExcessTwoYearsPriorExceptionApplies";
    TransferIRADistributionReason["RqdRemoveExcessPriorYearExceptionApplies"] = "RqdRemoveExcessPriorYearExceptionApplies";
    TransferIRADistributionReason["RqdExcessAnnualAdditions"] = "RqdExcessAnnualAdditions";
    TransferIRADistributionReason["RqdQualifiedDistribution"] = "RqdQualifiedDistribution";
    TransferIRADistributionReason["RqdDistributionExceptionApplies"] = "RqdDistributionExceptionApplies";
})(TransferIRADistributionReason || (TransferIRADistributionReason = {}));
export var CashieringSearchEntityType;
(function (CashieringSearchEntityType) {
    CashieringSearchEntityType["Transfer"] = "Transfer";
    CashieringSearchEntityType["AchRelationship"] = "AchRelationship";
    CashieringSearchEntityType["TransferRecipientBank"] = "TransferRecipientBank";
    CashieringSearchEntityType["TransferWireInstruction"] = "TransferWireInstruction";
    CashieringSearchEntityType["AchTransfer"] = "AchTransfer";
    CashieringSearchEntityType["CheckTransfer"] = "CheckTransfer";
    CashieringSearchEntityType["WireTransfer"] = "WireTransfer";
})(CashieringSearchEntityType || (CashieringSearchEntityType = {}));
export var CashieringDocumentType;
(function (CashieringDocumentType) {
    CashieringDocumentType["BankStatement"] = "BankStatement";
    CashieringDocumentType["VoidedCheck"] = "VoidedCheck";
})(CashieringDocumentType || (CashieringDocumentType = {}));
export const AllCashieringDocumentTypes = [CashieringDocumentType.BankStatement, CashieringDocumentType.VoidedCheck];
export const AccountStatuses = [
    'Prospect',
    'ProspectApplicationStarted',
    'ProspectApplicationCompleted',
    'ProspectApplicationExpired',
    'Processing',
    'ProcessingItemsMissing',
    'ActiveNotFunded',
    'Active',
    'Closed',
    'ClosedNeverFunded',
    'Rejected',
    'Deceased',
    'ActiveClosingTradesOnly',
];
//# sourceMappingURL=Cashiering.js.map